import React, { useCallback, useEffect, useRef, useState } from 'react'
import hero from '../assets/Banner.png'
import mhero from '../assets/mbanner2.png'
import car from '../assets/car.png'
import insole from '../assets/insole.png'
import key from '../assets/key.png'
import pet from '../assets/pet.png'
import phone from '../assets/homepage.png'
import trackcircle from '../assets/Trackcircle.png'
import { useNavigate } from 'react-router-dom'
import VoiceCommand from './VoiceCommand'
import { BrowserView, MobileView } from 'react-device-detect';
import { getStarted, sanitizeInput } from '../Logic/index01'
import { messageDisplay, T } from '../Auth/Util'
import Spinner from '../Logic/Spinner'
import { screensize, useMobile } from './Screensize'


const  Hero = () => {

const histroy = useNavigate();
const [isMobile, setMobile] = useState(false);
const [isLoad, setLoad] = useState(false); 
const [email, setEmail] = useState(""); 
 const isPhone = screensize();




const nav = (url,index) => {
    upTo(index);
    histroy(url);
  }



  const upTo = (index) => {
     window.scrollTo({top: index,left: 0,behavior: 'smooth'});
    document.scrollingElement.scrollTo({ top: index, behavior: 'smooth' });
  }




  const submitSubscribe = async ()  => {
    if(email.trim().length > 10 && email.includes("@gmail.com") && sanitizeInput(email).length > 10){
      console.log(`EM ${sanitizeInput(email)}`);
      
       setLoad(true)
        let res = await getStarted(email);
          if(res.toString().includes("Sent")){
             upTo(0);
             setLoad(false);
            histroy("/start"); 
        }else{
            setLoad(false);
        }
    }else{
      setLoad(false);
      messageDisplay("Invalid email",1);
    }
  }




  useEffect(() => {
      setMobile(window.innerWidth < 700)
  },[]);

  return (
    <>
      <main class="flex-1 w-full mx-auto">
       <section>
         <div class="flex flex-col gap-8 md:flex-row md:items-center" >
             <section class="hero-bg w-full flex items-center pt-24 pb-24" id='fade-bottom'>
              <div class="max-w-6xl mx-auto px-6 w-full">
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-16 items-cente  relative">

                <div>
                    <div class="chip animate-slideUp mb-6"><span class="chip-dot"></span>Trusted Security</div>
                    <h1 class="font-display animate-slideUpD1 text-5xl sm:text-6xl lg:text-[4.5rem] font-extrabold leading-[1.03] tracking-tight text-white">
                      Keep what<br/>matters <span class="text-[#3b8dff]">close</span>
                    </h1>
                    <p class="animate-slideUpD2 mt-5 text-white/60 text-base leading-relaxed max-w-md">
                      Versatile tracking for automobiles, people, pets, and accessories with military-grade accuracy. Real-time protection for your world.
                    </p>
                    <div class="animate-slideUpD3 mt-9 flex flex-wrap gap-3">
                    <a  onClick={(e) => nav("/shop/0",0)}  class="animate-glowPulse  text-white font-display font-bold text-sm px-7 py-3.5 rounded-xl hover:opacity-90 transition-opacity shadow-lg" style={{backgroundColor:T.buttonColor}}>
                        Shop Now
                    </a>
                    <a  onClick={(e) => upTo( isMobile ? 2700 : 1100)} class="text-white  z-50 font-display font-semibold text-sm px-7 py-3.5 rounded-xl border border-white/20 bg-white/[0.08] backdrop-blur-sm hover:bg-white/[0.15] transition-colors">
                        Explore Features
                    </a>
                    </div>
                    

                    <div class="mt-12 flex items-center divide-x divide-white/15">
                    <div class="pr-7">
                        <p class="font-display text-3xl font-extrabold text-white">2k+</p>
                        <p class="text-white/45 text-xs mt-1">Devices Active</p>
                    </div>
                     <div class="px-7 block">
                        <p class="font-display text-3xl font-extrabold text-white ">5s </p>
                        <p class="text-white/45 text-xs mt-1">Update Interval</p>
                    </div>
                    <div class="pl-7">
                        <p class="font-display text-3xl font-extrabold text-white">8mo</p>
                        <p class="text-white/45 text-xs mt-1">Battery Life</p>
                    </div>
                    </div>
                </div>

                
                   
               

                    <div class="relative h-[460px] flex items-center justify-center"> 
                               

                              <div className='absolute ml-0 h-96 md:-ml-36 mt-5 '>
                                <BrowserView>
                                  <img  className='h-80 sm:h-96 object-cover ' loading='lazy'  src={hero}/> 
                                </BrowserView>
                                <MobileView>
                                     <img  className='object-cover -ml-1 sm:-ml-0' loading='lazy'  src={mhero}/> 
                                </MobileView>
                              </div>
                          
                
                            <div class="absolute top-4 z-20 bg-white/10 backdrop-blur border border-white/20 text-white text-xs px-4 py-1.5 rounded-full flex items-center gap-2 font-display sm:-mt-0 -mt-10">
                            <span class="w-2 h-2 rounded-full bg-green-400 animate-pulse "></span>
                              Live Tracking On
                            </div> 

                        
                            <div class="animate-floatB relative z-10 rounded-2xl px-8 py-6 flex flex-col items-center" style={{boxShadow:"0 30px 80px rgba(0,0,0,.45),0 0 0 1px rgba(255,255,255,.1);"}}>
                            <div class="-mt-1 sm:-mt-10  ml-2  sm:ml-0 bg-[#1a6ef5] text-white text-[10px] font-display font-bold px-3 py-1 rounded-full tracking-widest">ALL DEVICES ACTIVE</div>
                            </div>

                            <div class="absolute animate-bounce top-14 right-0 sm:right-10 w-12 h-12 rounded-2xl flex items-center justify-center z-20 text-[48px] lg:text-[45px]">🛵</div>
                            <div class="absolute animate-bounce top-18 right-0 sm:right-10 w-12 h-12 rounded-2xl flex items-center justify-center z-20 text-[48px] lg:text-[45px]">🚘</div>
                            <div class="absolute animate-bounce top-14 left-6 sm:left-10 w-12 h-12 rounded-2xl flex items-center justify-center z-20 text-[48px] lg:text-[35px]">📍</div>
                            <div class="absolute animate-bounce top-18 left-2 sm:left-10 w-12 h-12 rounded-2xl flex items-center justify-center z-20 text-[48px] lg:text-[35px]">🚍</div>
                            <div class="absolute animate-bounce bottom-14 left-2 w-12 h-12 sm:left-6 rounded-xl flex items-center justify-center z-20 text-[48px] lg:text-[35px]">📱</div>
                            <div class="absolute animate-bounce bottom-14 right-1 w-12 h-12 sm:right-10 rounded-xl flex items-center justify-center z-20 text-[45px] lg:text-[35px]">🧒</div>
                      </div>
                     </div>
                    </div>
                    </section>
 
                    </div>
                </section>


            <section class="max-w-6xl mx-auto px-6 md:px-10 py-24">
              <h2 class="text-center text-3xl sm:text-4xl font-extrabold text-slate-900 mb-16">
                3 steps process
              </h2>
          
              <div class="grid md:grid-cols-3 gap-12">    
                <div class="flex items-start gap-4">
                  <svg class="w-14 h-14 flex-shrink-0" viewBox="0 0 64 64" fill="none" stroke="#1c3f6e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="26" cy="20" r="7"/>
                    <path d="M13 40c0-8 6-13 13-13s13 5 13 13"/>
                    <line x1="8" y1="27" x2="14" y2="27"/>
                    <line x1="38" y1="27" x2="44" y2="27"/>
                    <circle cx="40" cy="38" r="9" stroke="#e35c33" fill="white"/>
                    <path d="M35.5 38l3 3 6-6" stroke="#e35c33"/>
                  </svg>
                  <div>
                    <h3 class="font-bold text-lg text-slate-900 mb-2">Download the App</h3>
                    <p class="text-slate-500 leading-relaxed">Launch the App Store on iOS or Google Play Store, Type the name of the app into the search bar and install.</p>
                  </div>
                </div>
          
              
                <div class="flex items-start gap-4">
                  <svg class="w-14 h-14 flex-shrink-0" viewBox="0 0 64 64" fill="none" stroke="#1c3f6e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="10" y="12" width="26" height="36" rx="2"/>
                    <circle cx="19" cy="24" r="4"/>
                    <path d="M13 36c0-3.5 2.5-6 6-6s6 2.5 6 6"/>
                    <line x1="28" y1="21" x2="32" y2="21"/>
                    <line x1="16" y1="42" x2="30" y2="42"/>
                    <line x1="16" y1="38" x2="30" y2="38"/>
                    <circle cx="34" cy="20" r="9" stroke="#e35c33" fill="white"/>
                    <path d="M29.5 20l3 3 6-6" stroke="#e35c33"/>
                  </svg>
                  <div>
                    <h3 class="font-bold text-lg text-slate-900 mb-2">Create account</h3>
                    <p class="text-slate-500 leading-relaxed">Launch the application on your mobile device, Sign up and verify to activate your account</p>
                  </div>
                </div>
          
            
                <div class="flex items-start gap-4">
                  <svg class="w-14 h-14 flex-shrink-0" viewBox="0 0 64 64" fill="none" stroke="#e35c33" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 26c0-7 4-11 8-11s8 4 8 11" stroke="#1c3f6e"/>
                    <path d="M14 26h28l3 20a4 4 0 0 1-4 4.5H15A4 4 0 0 1 11 46l3-20z" stroke="#1c3f6e"/>
                    <line x1="14" y1="34" x2="42" y2="34" stroke="#1c3f6e"/>
                    <text x="26" y="45" font-size="10" fill="#e35c33" stroke="none" font-family="Inter, sans-serif" font-weight="700">$</text>
                    <circle cx="46" cy="18" r="10" fill="white"/>
                    <circle cx="46" cy="18" r="8"/>
                    <text x="42.5" y="21.5" font-size="9" fill="#e35c33" stroke="none" font-family="Inter, sans-serif" font-weight="700">A</text>
                  </svg>
                  <div>
                    <h3 class="font-bold text-lg text-slate-900 mb-2">Login explore</h3>
                    <p class="text-slate-500 leading-relaxed">Once user email is verified, you receive a 200 free credit instantly to your account wallet.</p>
                  </div>
                </div>
          
              </div>
            </section>
 

          <section className="max-w-7xl mx-auto px-6 md:px-10 pt-16 pb-4 grid md:grid-cols-2 gap-12 items-center">
 
                <div class="relative flex justify-center md:justify-start">
                  <div class="absolute w-[380px] h-[380px] md:w-[420px] md:h-[420px] rounded-full bg-blue-50 -z-10 animate-pulse"></div>
                    <img loading='lazy'  alt='Track Cirlce'  src={trackcircle}/>
                </div>
            
                <div>
                  <h1 class="text-3xl sm:text-4xl font-extrabold leading-snug text-slate-900">
                    Specialized Event <br/>
                    <span style={{color:T.themeblue}}> Circles</span>
                  </h1>
                  <p class="mt-6 text-slate-500 max-w-md leading-relaxed">
                   Say goodbye to cluttered maps and disorganized tracking. Our Event Circles feature lets you segment your tracking into private, dedicated hub environments for maximum focus and security.
                  </p>
                  <div class="mt-8 flex flex-wrap gap-4">
                    <a onClick={(e) => nav("/start", isPhone ? 750 : 410)} class="inline-block mt-8 font-mono text-xs uppercase tracking-wider px-6 py-3 border rounded-sm underline-swipe" style={{borderColor:""}}>Read more →</a>
                  </div>
                </div>
              </section>
            
              <section class="lg:ml-36 lg:mr-36 ml-0 mr-0">
                <div class="max-w-7xl mx-auto px-6 md:px-10 py-10 grid md:grid-cols-2 gap-12 items-center">
            
                  <div>
                    <h2 class="text-4xl font-extrabold text-slate-900">Instant <span style={{color:T.themeblue}}>Geofence</span> Alerts</h2>
                    <p class="mt-4 text-slate-500 max-w-sm leading-relaxed">
                      Custom Virtual Perimeters draw unique digital boundaries directly onto your mobile map application, get real-time entrance & exit alerts. 
                      Schedule unique geofences that adjust automatically based on school, work, or curfew times to eliminate false alarms.
                    </p>
                    <a href="#apply" class="inline-block mt-6 px-6 py-3 rounded bg-navy text-white font-semibold text-sm hover:bg-navy-dark transition">Apply Now</a>
            
                    <p class="text-xs font-semibold tracking-widest text-slate-400">DOWNLOAD OUR APP</p>
                    <div class="mt-3 flex flex-wrap gap-3">
                      <a  href="https://beeppeeappmode.web.app/" 
                          target="_blank" 
                          rel="noopener noreferrer" class="flex items-center gap-2 bg-slate-900 text-white px-4 py-2.5 rounded-lg hover:bg-slate-800 transition">
                        <svg class="w-6 h-6" viewBox="0 0 24 24" fill="currentColor"><path d="M17.05 20.28c-.98.95-2.05.88-3.08.5-1.09-.4-2.09-.42-3.24 0-1.44.53-2.2.36-3.06-.5C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.53 4.08zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/></svg>
                        <span class="text-left leading-none">
                          <span class="block text-[10px] text-slate-300">Download on the</span>
                          <span class="block text-sm font-semibold -mt-0.5">App Store</span>
                        </span>
                      </a>
                      
                      <a  href="https://beeppeeappmode.web.app/" 
                          target="_blank" 
                          rel="noopener noreferrer" class="flex items-center gap-2 bg-slate-900 text-white px-4 py-2.5 rounded-lg hover:bg-slate-800 transition">
                        <svg class="w-6 h-6" viewBox="0 0 24 24"><path fill="#00d9ff" d="M3.6 2.3c-.3.3-.5.7-.5 1.2v17c0 .5.2.9.5 1.2l.1.1L13.6 12 3.7 2.2l-.1.1z"/><path fill="#00f076" d="M17 15.4l-3.4-3.4 3.4-3.4 4.1 2.3c.9.5.9 1.7 0 2.2l-4.1 2.3z"/><path fill="#ff3a44" d="M17 8.6l-3.4 3.4L3.6 2.3c.4-.4 1-.5 1.6-.2L17 8.6z"/><path fill="#ffcf00" d="M17 15.4L5.2 21.9c-.6.3-1.2.2-1.6-.2L13.6 12l3.4 3.4z"/></svg>
                        <span class="text-left leading-none">
                          <span class="block text-[10px] text-slate-300">GET IT ON</span>
                          <span class="block text-sm font-semibold -mt-0.5">Google Play</span>
                        </span>
                      </a>
                    </div>
                  </div>
            

                  <div class="flex justify-center md:justify-end">
                    <style>{`
                      @keyframes lowBounce {
                        0%, 100% { 
                          transform: translateY(-55px); 
                          animation-timing-function: cubic-bezier(0.8, 0, 1, 1); 
                        }
                        50% { 
                          transform: translateY(0); 
                          animation-timing-function: cubic-bezier(0, 0, 0.2, 1); 
                        }
                       }
                      .animate-low-bounce {
                        animation: lowBounce 2s infinite;
                      }
                    `}</style>
                    <img loading='lazy'  alt='Track Cirlce'  src={phone} className='animate-low-bounce'/>
                </div>
                </div>
              </section>
             

             <div  class="flex-1 max-w-[1200px] mx-auto w-full px-4 md:px-10 mt-2">
                <section id='explore' class="pt-10">
                <div class="flex items-center justify-center text-center px-4 pb-6">
                    <h2 class="text-[#0d191c] text-3xl font-bold leading-tight tracking-[-0.015em]">Explore Our Categories</h2>
                </div>


                <BrowserView>
                <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 p-4">
                    <div  class="group relative bg-[#CBE5F4] bg-contain bg-center rounded-xl p-6 aspect-square cursor-pointer hover:scale-[1.02] transition-transform" data-alt="Beeppee tracker for luxury car" style={{backgroundImage:`url(${car})`}}>
                        <div className='-mt-0 lg:mt-52'>
                            <div class="z-10">
                                <p class="text-accent-pink text-xl lg:text-xl  font-bold leading-tight">Vehicle/Bike</p>
                                <p class="text-primary text-xs font-medium mt-1">Real-time GPS security</p>
                            </div>
                            <div class="absolute top-4 right-4 bg-primary/20 backdrop-blur-md rounded-full p-2 opacity-0 group-hover:opacity-100 transition-opacity">
                                   <span class="material-symbols-outlined text-white">star</span>
                                    <span class="material-symbols-outlined text-white">star</span>
                                    <span class="material-symbols-outlined text-white">star</span>
                                    <span class="material-symbols-outlined text-white">star</span>
                            </div>
                        </div>
                        </div>

                        <div class="group relative bg-[#CBE5F4] bg-contain bg-center rounded-xl p-6 aspect-square cursor-pointer hover:scale-[1.02] transition-transform" data-alt="Close up of a smart beeppee shoe insole tracking device" style={{backgroundImage:`url(${insole})`}}>
                          <div className='-mt-0 lg:mt-52'>
                            <div class="z-10">
                            <p class="text-accent-pink text-xl lg:text-xl  font-bold leading-tight">Insole</p>
                            <p class="text-primary text-xs font-medium mt-1">Safety for elderly &amp; kids</p>
                            </div>
                            <div class="absolute top-4 right-4 bg-accent-pink/20 backdrop-blur-md rounded-full p-2 opacity-0 group-hover:opacity-100 transition-opacity">
                                    <span class="material-symbols-outlined text-white">star</span>
                                    <span class="material-symbols-outlined text-white">star</span>
                                    <span class="material-symbols-outlined text-white">star</span>
                            </div>
                          </div>
                        </div>


                        <div class="group relative  bg-[#CBE5F4] bg-contain bg-center  rounded-xl  p-6 aspect-square cursor-pointer hover:scale-[1.02] transition-transform" data-alt="Happy dog wearing a tracking collar" style={{backgroundImage:`url(${pet})`}}>
                          <div className='mt-64 lg:mt-52'>
                            <div class="z-10">
                                <p class="text-accent-pink text-xl lg:text-xl font-bold leading-tight">Pet</p>
                                <p class="text-primary text-xs font-medium mt-1">Never lose your best friend</p>
                            </div>
                            <div class="absolute top-4 right-4 bg-primary/20 backdrop-blur-md rounded-full p-2 opacity-0 group-hover:opacity-100 transition-opacity">
                                   <span class="material-symbols-outlined text-white">star</span>
                                    <span class="material-symbols-outlined text-white">star</span>
                            </div>
                            </div>
                        </div>
                        
                        <div class="group relative bg-[#CBE5F4] bg-contain bg-center h-auto rounded-xl p-6 aspect-square cursor-pointer hover:scale-[1.02] transition-transform" data-alt="Set of keys and a travel bag with a smart tag" style={{backgroundImage:`url(${key})`}}>
                         <div className='mt-64 lg:mt-52'>
                            <div class="z-10">
                              <p class="text-accent-pink text-xl lg:text-xl font-bold leading-tight">Key holder</p>
                              <p class="text-primary text-xs font-medium mt-1">Tags for keys &amp; bags</p>
                            </div>
                            <div class="absolute top-4 right-4 bg-accent-pink/20 backdrop-blur-md rounded-full p-2 opacity-0 group-hover:opacity-100 transition-opacity">
                                   <span class="material-symbols-outlined text-white">star</span>
                                    <span class="material-symbols-outlined text-white">star</span>
                            </div>
                          </div>
                        </div>
                   </div>
                   </BrowserView>

                   <MobileView>
                      <div id='inventory' class="flex flex-row overflow-x-auto  h-auto snap-x snap-mandatory gap-4  p-4 w-full">


                          <div className='flex items-center rounded-lg justify-center shrink-0 snap-center'>
                            <div class=" bg-[#CBE5F4] bg-contain bg-no-repeat bg-center h-auto rounded-lg w-72 p-6 aspect-square cursor-pointer hover:scale-[1.02] transition-transform" data-alt="Set of keys and a travel bag with a smart tag" style={{backgroundImage:`url(${car})`}}>
                              <div className='mt-64 lg:mt-52'>
                                  <div class="z-10">
                                    <p class="text-accent-pink text-xl lg:text-xl font-bold leading-tight">Vehicle/Bike</p>
                                    <p class="text-primary text-xs font-medium mt-1">Real-time GPS security</p>
                                  </div>
                                  <div class="flex justify-end self-end p-2  transition-opacity">
                                    <span class="material-symbols-outlined text-white">star</span>
                                    <span class="material-symbols-outlined text-white">star</span>
                                    <span class="material-symbols-outlined text-white">star</span>
                                  </div>
                              </div>
                           </div>
                         </div>

                         <div className='flex items-center rounded-lg justify-center shrink-0 snap-center'>
                            <div class=" bg-[#CBE5F4] bg-contain bg-no-repeat bg-center h-auto rounded-lg w-72 p-6 aspect-square cursor-pointer hover:scale-[1.02] transition-transform" data-alt="Set of keys and a travel bag with a smart tag" style={{backgroundImage:`url(${insole})`}}>
                              <div className='mt-64 lg:mt-52'>
                                  <div class="z-10">
                                    <p class="text-accent-pink text-xl lg:text-xl font-bold leading-tight">Insole</p>
                                    <p class="text-primary text-xs font-medium mt-1">Safety for elderly &amp; kids</p>
                                  </div>
                                  <div class="flex justify-end self-end p-2  transition-opacity">
                                    <span class="material-symbols-outlined text-white">star</span>
                                    <span class="material-symbols-outlined text-white">star</span>
                                  </div>
                              </div>
                           </div>
                         </div>



                         <div className='flex items-center rounded-lg justify-center shrink-0 snap-center'>
                            <div class=" bg-[#CBE5F4] bg-contain bg-no-repeat bg-center h-auto rounded-lg w-72 p-6 aspect-square cursor-pointer hover:scale-[1.02] transition-transform" data-alt="Set of keys and a travel bag with a smart tag" style={{backgroundImage:`url(${pet})`}}>
                              <div className='mt-64 lg:mt-52'>
                                  <div class="z-10">
                                    <p class="text-accent-pink text-xl lg:text-xl font-bold leading-tight">Pet</p>
                                    <p class="text-primary text-xs font-medium mt-1">Never lose your best friend</p>
                                  </div>
                                  <div class="flex justify-end self-end p-2  transition-opacity">
                                     <span class="material-symbols-outlined text-white">star</span>
                                  </div>
                              </div>
                           </div>
                         </div>


                          <div className='flex items-center rounded-lg justify-center shrink-0 snap-center'>
                            <div class=" bg-[#CBE5F4] bg-contain bg-no-repeat bg-center h-auto rounded-lg w-72 p-6 aspect-square cursor-pointer hover:scale-[1.02] transition-transform" data-alt="Set of keys and a travel bag with a smart tag" style={{backgroundImage:`url(${key})`}}>
                              <div className='mt-64 lg:mt-52'>
                                  <div class="z-10">
                                    <p class="text-accent-pink text-xl lg:text-xl font-bold leading-tight">Key holder</p>
                                    <p class="text-primary text-xs font-medium mt-1">Tags for keys &amp; bags</p>
                                  </div>
                                  <div class="flex justify-end self-end p-2  transition-opacity">
                                     <span class="material-symbols-outlined text-white">star</span>
                                  </div>
                              </div>
                           </div>
                         </div>


                      

                      </div>
                   </MobileView>
                </section>
                

                <section class="py-20 @container">
                    <div class="flex flex-col gap-10 px-4">
                    <div class="flex flex-col gap-4 text-center items-center">
                        <h2 class="text-[#0d191c] tracking-light text-[32px] font-bold leading-tight @[480px]:text-4xl @[480px]:font-black @[480px]:leading-tight @[480px]:tracking-[-0.033em] max-w-[720px]">
                            Why Choose Us
                        </h2>
                         <p class="text-[#4b8e9b] text-lg font-normal leading-normal max-w-[600px]">
                            Experience the best in GPS technology and device longevity. We combine military hardware with seamless software.
                        </p>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div class="flex flex-col gap-4 rounded-2xl border border-[#cfe4e8]  bg-[#88CEDB] p-8 shadow-sm hover:shadow-md transition-shadow">
                    <div class="w-12 h-12  rounded-xl flex items-center justify-center text-primary bg-[#10D0F6]">
                            <span class="material-symbols-outlined text-3xl text-[#2ea4bb]">my_location</span>
                    </div>
                <div class="flex flex-col gap-2">
                <h3 class=" text-slate-700 text-xl font-bold leading-tight">Military-Grade Accuracy</h3>
                        <p class="text-slate-900 text-sm font-normal leading-relaxed">
                          Pinpoint location within 2 meters globally. Our satellites ensure you never lose track, even in dense urban environments.
                      </p>
                  </div>
                </div>
                

                <div class="flex flex-col gap-4 rounded-2xl border border-[#cfe4e8] bg-[#E1B7ED] p-8 shadow-sm hover:shadow-md transition-shadow">
                <div class="w-12 h-12 bg-accent-pink/10 rounded-xl flex items-center justify-center bg-[#FF90D2]">
                <span class="material-symbols-outlined text-3xl text-[#ff23b9]">battery_charging_full</span>
                </div>
                <div class="flex flex-col gap-2">
                <h3 class="text-slate-700  text-xl font-bold leading-tight">Long-Lasting Power</h3>
                        <p class="text-slate-900  text-sm font-normal leading-relaxed">
                            Proprietary power-saving modes allow batteries to last for up to 6 months on a single charge. Reliable when it matters most.
                        </p>
                </div>
                </div>
                <div class="flex flex-col gap-4 rounded-2xl border border-[#cfe4e8] bg-[#8AA3D7]  p-8 shadow-sm hover:shadow-md transition-shadow">
                <div class="w-12 h-12 rounded-xl flex items-center justify-center bg-[#5488f8]">
                <span class="material-symbols-outlined text-3xl text-[#1658EA]">notifications_active</span>
                </div>
                <div class="flex flex-col gap-2">
                  <h3 class="text-slate-700  text-xl font-bold leading-tight">Instant Alerts</h3>
                    <p class="text-slate-900 text-sm font-normal leading-relaxed">
                        Get notified immediately on your phone when a device leaves a safe zone or detects unusual movement.
                    </p>
                </div>
                </div>
                </div>
                </div>
                </section>

                <VoiceCommand/>
                
                <section class="mb-20 px-4">
                <div class="rounded-3xl bg-[#0d191c] dark:bg-[#1e3438] p-10 md:p-16 text-center flex flex-col items-center gap-6 relative overflow-hidden">
                  <div class="absolute top-0 right-0 w-64 h-64 bg-primary/20 rounded-full blur-[100px] -mr-32 -mt-32"></div>
                    <div class="absolute bottom-0 left-0 w-64 h-64 bg-accent-pink/20 rounded-full blur-[100px] -ml-32 -mb-32"></div>
                    <h2 class="text-white text-4xl font-black relative z-10">Ready to secure your world?</h2>
                    <p class="text-gray-300 max-w-lg relative z-10">Join 2000+ users who trust Beeppee for their tracking needs, get started today and subscribe to our monthly security tips.</p>
                    <div class="flex flex-col sm:flex-row gap-4 w-full max-w-md relative z-10">
                    <input value={email} onChange={(e) => setEmail(e.target.value)} class="flex-1 rounded-lg border-none px-4 py-3 bg-white/10 text-white placeholder-gray-400 focus:ring-2 focus:ring-primary" placeholder="Enter your email" type="email"/>
                    <button  onClick={() => submitSubscribe()} class="font-bold px-8 py-3 rounded-lg hover:text-[#f5f5f5] transition-colors text-white" style={{backgroundColor:T.buttonColor}}> {isLoad ? <div className='flex justify-center items-center  w-full'><Spinner  color={T.surface}  isloading={isLoad} h={25} w={25}/></div>  : "Get Started"}</button>
                  </div>
                </div>
             </section>
             </div>
        </main>
    </>
  )
}

export default Hero
